import { BrowserRouter, Route, Routes as Switch } from "react-router-dom";
import Alert from "../components/alert/index";
import Main from "../components/main"   

const Routes = () => {
    return (

        <BrowserRouter>
            <Alert />
            <Switch>
                <Route path="/" element={ <Main/> } />
                <Route path="*" element={<h1>404 Not Found</h1>} />
            </Switch>
        </BrowserRouter>
    );
};

export default Routes;
